import styled from "styled-components"
import Dropzone from "react-dropzone"

import {TextArea} from "@irati/ui/src/FormItem"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import padding from "@irati/ui/src/global/padding"
import {Label1, Para} from "@irati/ui/src/Labels"
import {FormGroup} from "@irati/ui/src/Form"

export const StyledTextArea = styled(TextArea)`
  textarea {
    resize: none;
  }
`

interface DropzoneProps {
  hasError: boolean
}

export const StyledDropzone = styled(Dropzone)<DropzoneProps>`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  border: 2px dashed;
  border-color: ${({hasError, theme}) => {
    const {error, greys} = theme.colors
    return hasError ? error : greys.medium
  }};
  cursor: pointer;
  margin-top: 7px;
  min-height: 225px;
  padding: ${padding.base};
  text-align: center;
`

export const StyledUploadIcon = styled.img`
  display: block;
  text-align: center;
  margin: 0 auto ${padding.tiny};
  height: 50px;
`

export const StyledLabel = styled(Label1)`
  padding-bottom: ${padding.tiny};
`

export const StyledDescription = styled(Para)`
  color: ${({theme}) => theme.colors.greys.medium};
  font-size: 12px;
`

export const UploadedImage = styled.img`
  max-height: 100%;
  max-width: 100%;
`

export const StyledFormGroup = styled(FormGroup)`
  &.form-group {
    margin: 0;
  }
`

export const StyledIconTooltip = styled(IconTooltip)`
  margin-left: 5px;
  margin-top: 1px;
`
